export default function CaseStudies() {
  return null;
}